"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Animations = void 0;
const basicScroll = __importStar(require("basicscroll"));
const LoadingScreen_1 = require("./LoadingScreen");
const select_all_and_run_1 = require("../utils/select-all-and-run");
class Animations {
    static init() {
        const viewW = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        this.logoAnimation();
        this.hashtagParalex();
        this.textReelHorizontal();
        LoadingScreen_1.LoadingScreen.init();
        if (document.body.classList.contains('home') && viewW >= 992) {
            (0, select_all_and_run_1.SelectAllAndRun)('.hero-overflow', async (elements) => {
                const { HeroAnimation } = await Promise.resolve().then(() => __importStar(require(
                /* webpackChunkName: "heroAnimation" */
                '../class/HeroAnimation')));
                new HeroAnimation(elements);
            });
        }
    }
    static logoAnimation() {
        const logos = document.querySelectorAll('.logo-img');
        logos === null || logos === void 0 ? void 0 : logos.forEach((logo) => {
            const instance = basicScroll.create({
                elem: logo,
                from: 'top-top',
                to: 'bottom-bottom',
                direct: true,
                props: {
                    '--rotate': {
                        from: '-15deg',
                        to: '15deg',
                    },
                },
            });
            instance.start();
        });
    }
    static hashtagParalex() {
        const hashtags = document.querySelectorAll('.hashtag h2');
        hashtags === null || hashtags === void 0 ? void 0 : hashtags.forEach((hashtag) => {
            const instance = basicScroll.create({
                elem: hashtag,
                from: 'top-middle',
                to: 'bottom-bottom',
                direct: true,
                props: {
                    '--transform': {
                        from: '20px',
                        to: '-10px',
                    },
                },
            });
            instance.start();
        });
    }
    static textReelVertical() {
        const reels = document.querySelectorAll('.text-reel .reel-row');
        reels === null || reels === void 0 ? void 0 : reels.forEach((reel) => {
            const instance = basicScroll.create({
                elem: reel,
                from: 'top-top',
                to: 'bottom-bottom',
                direct: true,
                props: {
                    '--reel-left': {
                        from: '0',
                        to: '100px',
                    },
                    '--reel-right': {
                        from: '100px',
                        to: '0',
                    },
                },
            });
            instance.start();
        });
    }
    static textReelHorizontal() {
        const reels = document.querySelectorAll('.text-reel .reel-row');
        reels === null || reels === void 0 ? void 0 : reels.forEach((reel) => {
            const instance = basicScroll.create({
                elem: reel,
                from: 'top-top',
                to: 'bottom-bottom',
                direct: true,
                inside() {
                    var _a;
                    (_a = this.elem) === null || _a === void 0 ? void 0 : _a.classList.add('marquee');
                },
                outside() {
                    var _a;
                    (_a = this.elem) === null || _a === void 0 ? void 0 : _a.classList.remove('marquee');
                },
                props: {
                    '--reel-left': {
                        from: '0',
                        to: '100px',
                    },
                    '--reel-right': {
                        from: '100px',
                        to: '0',
                    },
                },
            });
            instance.start();
        });
    }
}
exports.Animations = Animations;
